<div class="w-100 float-left">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium m-0" *ngIf="!isEdit">Add Dimension </h5>
        <h5 class="medium m-0" *ngIf="isEdit">Edit Dimension - {{dimensionData.dimCode}}</h5>
        <div class="ml-alert"></div>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" (click)="onBack()">
            <i class="fa fa-arrow-left mr-sm-2"></i> Back
        </button>
    </div>
    <div class="w-100 float-left mt-3">
        <div class='col-lg-6 col-md-6 float-left left-clear'>
            <div class="form-group">
                <label> Name
                    <span class="text-danger medium">*</span>
                </label>
                <input maxlength="200" type="text" class="form-control" [(ngModel)]="dimensionData.name" name="name"/>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left'>
            <div class="form-group">
                <label> Display Name
                    <!-- <span class="text-danger medium">*</span> -->
                </label>
                <input maxlength="200" type="text" class="form-control" [(ngModel)]="dimensionData.displayName"
                       name="name"/>
            </div>
        </div>
        <div class='col-lg-6 col-md-6 float-left left-clear'>
            <label for="dropDown">Type</label>
            <select class="form-control light-bg" (change)="onTypeSelection($event)">
                <option [attr.selected]="isDimTime == false ? true : null" value="custom">Custom</option>
                <option [attr.selected]="isDimTime == true ? true : null" value="time">Time</option>
            </select>
        </div>
        <div class='col-lg-6 col-md-6 float-left'>
            <label> Description
                <span class="text-danger medium"></span>
            </label>
            <textarea maxlength="350" class="form-control" rows="1" [(ngModel)]="dimensionData.description"
                      name="description"></textarea>
        </div>
        <div class='col-lg-6 col-md-6 float-left  left-clear'>
            <label for="dropDown"> Record Format For Hierarchy Level </label>
            <select *ngIf="parent != 'wizard'" class="form-control light-bg" (change)="onSelectOfRecord($event)">
                <option value='selectOne'>Select One</option>
                <option [attr.selected]="dimHierarchyDataObject.recordFormatId == rff.id ? true : null" [value]='rff.id'
                        *ngFor="let rff of recordFormatList">{{rff.name}}
                </option>
            </select>
            <input *ngIf="parent == 'wizard'" readonly class="form-control" type="text" id="recordFormatName"
                   maxlength="100" [(ngModel)]="recordFormat.displayName"
            />
        </div>
        <div class='col-lg-6 col-md-6 float-left'>
            <div class="form-group">
                <label> Dimension Hierarchy Name
                    <span class="text-danger medium">*</span>
                </label>
                <input maxlength="200" type="text" class="form-control" [(ngModel)]='dimHierarchyDataObject.name'
                       name="name"/>
            </div>
        </div>
        <div class="col-lg-2 col-md-2 float-left left-clear">
            <button id="addLevels" (click)="addLevels()" class="btn btn-primary float-left">Add Levels</button>
        </div>

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left my-4 form-group accordionss"
             *ngIf="dimHierarchyLevelData && dimHierarchyLevelData.length > 0 ">
            <ngb-accordion class="w-100">
                <ngb-panel id="someId" title="View Dimension Levels">
                    <ng-template ngbPanelContent>
                        <div class="w-100 float-left mt-3">
                            <div class="light-bg w-100 float-left p-2 grid-details">
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Level Name">
                                    <h6 class="mb-lg-0 medium text-truncate"> Level Name </h6>
                                </div>
                                <div *ngIf="isDimTime" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     ngbTooltip="Type">
                                    <h6 class="mb-lg-0 medium text-truncate"> Type </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     *ngIf='selectedRFF != undefined' ngbTooltip="Record Format Field">
                                    <h6 class="mb-lg-0 medium text-truncate"> Record Format Field </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     *ngIf='selectedRFF != undefined' ngbTooltip="Name Field">
                                    <h6 class="mb-lg-0 medium text-truncate"> Name Field </h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                                     *ngIf='selectedRFF != undefined' ngbTooltip="Ordinal Column">
                                    <h6 class="mb-lg-0 medium text-truncate"> Ordinal Column </h6>
                                </div>
                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center"
                                     ngbTooltip="Actions">
                                    <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                                </div>
                            </div>
                        </div>
                        <div *ngFor="let level of dimHierarchyLevelData; let i = index"
                             dnd-sortable-container [sortableData]="dimHierarchyLevelData">
                            <div class="w-100 float-left p-md-2 grid-details" (onDropSuccess)="reorder()" dnd-sortable
                                 [sortableIndex]="i">
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                    <h6 class="mb-lg-0 text-truncate">
                                        <input maxlength="200" type="text " [(ngModel)]="level.displayName"
                                               class="w-full p-sm b-a"/></h6>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"
                                     *ngIf="isDimTime">
                                    <select [(ngModel)]='level.levelType' [attr.id]="i" class="w-full p-sm b-a">
                                        <option [disabled]=true value=null>Select One</option>
                                        <option value="TimeDays">Day</option>
                                        <option value="TimeWeeks">Week</option>
                                        <option value="TimeMonths">Month</option>
                                        <option value="TimeYears">Year</option>
                                        <option value="TimeQuarters">Quarter</option>
                                    </select>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"
                                     *ngIf='selectedRFF != undefined'>
                                    <select [attr.id]="i" (change)="OnSelectRFFields($event, 'field1')"
                                            class="col-12 p-sm b-a">
                                        <option value="selectOne">Select One</option>
                                        <ng-container *ngIf="parent != 'wizard'">
                                            <option [attr.selected]="level.recordFormatFieldId == fields.id ? true : null"
                                                    [value]='fields.id'
                                                    *ngFor='let fields of selectedRFF.recordFormatFieldData'>
                                                {{fields.fieldName}}
                                            </option>
                                        </ng-container>
                                        <ng-container *ngIf="parent == 'wizard'">
                                            <option [attr.selected]="level.recordFormatFieldId == fields.refId ? true : null"
                                                    [value]='fields.refId'
                                                    *ngFor='let fields of selectedRFF.recordFormatFieldData'>
                                                {{fields.fieldName}}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"
                                     *ngIf='selectedRFF != undefined'>
                                    <select [attr.id]="i" (change)="OnSelectRFFields($event, 'field2')"
                                            class="col-12 p-sm b-a">
                                        <option value="selectOne">Select One</option>
                                        <ng-container *ngIf="parent != 'wizard' ">
                                            <option [attr.selected]="level.nameFieldId == fields.id ? true : null"
                                                    [value]='fields.id'
                                                    *ngFor='let fields of selectedRFF.recordFormatFieldData'>
                                                {{fields.fieldName}}
                                            </option>
                                        </ng-container>
                                        <ng-container *ngIf="parent == 'wizard'">
                                            <option [attr.selected]="level.nameFieldId == fields.refId ? true : null"
                                                    [value]='fields.refId'
                                                    *ngFor='let fields of selectedRFF.recordFormatFieldData'>
                                                {{fields.fieldName}}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left left-clear"
                                     *ngIf='selectedRFF != undefined'>
                                    <select [attr.id]="i" (change)="OnSelectRFFields($event, 'field3')"
                                            class="col-12 p-sm b-a">
                                        <option value="selectOne">Select One</option>
                                        <ng-container *ngIf="parent != 'wizard'">
                                            <option [attr.selected]="level.ordinalFieldId == fields.id ? true : null"
                                                    [value]='fields.id'
                                                    *ngFor='let fields of selectedRFF.recordFormatFieldData'>
                                                {{fields.fieldName}}
                                            </option>
                                        </ng-container>
                                        <ng-container *ngIf="parent == 'wizard'">
                                            <option [attr.selected]="level.ordinalFieldId == fields.refId ? true : null"
                                                    [value]='fields.refId'
                                                    *ngFor='let fields of selectedRFF.recordFormatFieldData'>
                                                {{fields.fieldName}}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                                    <h6 class="mb-lg-0 text-truncate">
                                        <i class="fa fa-trash mr-2" [attr.id]="i"
                                           (click)="onLevelDelete($event, level.displayName)" id=" delete "> Delete
                                        </i>
                                    </h6>
                                </div>
                            </div>

                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>

        <div class="col-lg-2 col-md-2 float-right">
            <button class="btn btn-primary float-right" [disabled]="saveButton" (click)="save()">Save</button>
        </div>

    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dimensionEdit.component.html